const DocumentType = ["Catalogue","Flyer","Logo","Newsletter","PowerPoint","Video"];

let documentTypeList = [];
for(let i in DocumentType)
    documentTypeList.push({ID:i,Name:DocumentType[i]});

export { DocumentType,documentTypeList };




